<template>
    <people :people="instructors" @updateChosen="chosen => chosenInstructor = chosen">
        <template slot="chosen-card">
            <chosen-person v-if="chosenInstructor.firstName"
                           :first-name="chosenInstructor.firstName"
                           :last-name="chosenInstructor.lastName"
                           :img="$helper.imgServerUrl() + chosenInstructor.img"
                           :phone="chosenInstructor.phone"
                           :email="chosenInstructor.email"
                           :info-text="instructorInfoTextById[chosenInstructor.id] ? instructorInfoTextById[chosenInstructor.id].info : ''"
            >
            </chosen-person>
        </template>
    </people>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import People from "../content/club/people/People";
    import ChosenPerson from "../content/club/people/ChosenPerson";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "InstructorPage",
        components: {ChosenPerson, People},
        computed: {
            ...mapGetters(['instructors', 'instructorInfoTextById'])
        },
        directives: {
            Resize, Scroll
        },
        data() {
            return {
                chosenInstructor: {}
            }
        },
        methods: {
            ...mapActions(['getAllUsers', 'getCoachInfoText'])
        },
        mounted() {
            if (this.instructors.length === 0) {
                this.getAllUsers()
            }
            if (!(this.instructorInfoTextById && this.instructorInfoTextById.length > 0)) {
                this.getCoachInfoText()
            }

            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)

        }
    }
</script>
